import axios from 'axios';

export function getRecentProjects() {
  return axios
    .get(
      `${process.env.GATSBY_CONTENT_API_URL}/projects/${process.env.GATSBY_FRONTEND_DOMAIN}`,
    )
    .then((res) => res)
    .catch((err) => Promise.reject(err));
}

export function submitProject(formData, gclid, msclkid) {
  return axios
    .post(
      `${process.env.GATSBY_CONTENT_API_URL}/projects/submit/${process.env.GATSBY_FRONTEND_DOMAIN}`,
      formData,
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
        params: {
          ...(gclid ? { gclid } : msclkid ? { msclkid } : null),
        },
      },
    )
    .then((res) => res)
    .catch((err) => Promise.reject(err));
}
